export default "__VITE_ASSET__JnGDzxNC__"